<template>
    <div>
        <app-sub-title text="Comercios"></app-sub-title>
        <b-button variant="primary" class="btn-block-xs-only" @click="startSaveStore"><i class="fa fa-plus"></i> Crear comercio</b-button>
        <app-stores-filters
            @filter="onFilter"
            :venues="venues"

        />
        <app-stores-list :data="data"
            @change-page="changePage"
            @login-store="loginStore"
            @update-store="startUpdate"
            @remove-store="startRemove"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->
        <app-pop-up title="Formulario comercio" size="large" id="store-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <app-store-form :myStore="selectedStore" id="store-form" :onSave="onSave" :edit="edit" />
            </div>
            <div slot="buttons">
                <b-button variant="confirm" :disabled="inProgress" class="btn-block-xs-only" @click="$bus.$emit('store-form.save')"><i class="fa fa-floppy-o"></i> Guardar comercio</b-button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="store-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar este comercio?</h2></div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteStore(selectedStore)"><i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación</button>
            </div>
        </app-pop-up>
        <!-- Fin pop up's -->
    </div>
</template>

<script>
import StoresList from './StoresList/StoresList';
import StoresFilters from './StoresFilters/StoresFilters';
import StoreForm from './StoreForm/StoreForm';
import storesRepository from '../../../repositories/stores.repository.js';
import {mapMutations, mapGetters} from 'vuex';
import * as mutations from '../../../store/commitTypes';
export default {
    components: {
        appStoresList: StoresList,
        appStoresFilters: StoresFilters,
        appStoreForm: StoreForm
    },

    data(){
        return{
            data: {},
            filters: {},
            venues: [],
            page: 1,
            // selectedStore: '',
            sort: {
                sortBy: 'name',
                sortDir: 'asc'
            },
            edit: false
        }
    },
    computed: {
        ...mapGetters(['selectedStore'])
    },
    methods: {
        ...mapMutations({
            setSelectedStore: mutations.SET_SELECTED_STORE
        }),
        loadStores(){
            const sr = {...storesRepository};
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir }; 
            sr.loadStores(filters, this.page)
            .then(({data}) => this.data = data)
            .catch(error => toastr.error('Ocurrió un error al cargar los comercios'));
        },
        onFilter(filters){
            this.filters = filters;
            this.loadStores();
        },
        changePage(page){
            this.page = page;
            this.loadStores();
        },
        startSaveStore() {
            this.setSelectedStore(null);
            this.edit = false;
            this.$bus.$emit('store-form.open');
        },
        loginStore(store) {
            this.setSelectedStore(store);
            this.$router.push({ name: 'adminStore'});
        },
        startUpdate(store){
            this.setSelectedStore(store);
            this.edit = true;
            this.$bus.$emit('store-form.open');
        },
        startRemove(store){
            this.setSelectedStore(store);
            this.$bus.$emit('store-remove.open');
        },
        onSave() {
            this.$bus.$emit('store-form.close');
            this.loadStores();
        },
        deleteStore(store) {
            const sr = {...storesRepository};
            sr.deleteStore(store.id)
                .then(({data}) => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.loadStores();
                        this.$bus.$emit('store-remove.close');
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el comercio');
                });
        },
        cleanForm() {
            this.$bus.$emit('store-form.clean');
            this.setSelectedStore(null);
            this.edit = false;
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadStores();
        },
        initialize(){
            this.loadStores();
        }
    },
    created(){
        this.initialize();
    }
}
</script>
    